import { PropsWithChildren } from 'react';

import { useOrganization } from '@clerk/clerk-react';

import NotFound from '@/pages/NotFound';

export const HasAccessToCourses = ({ children }: PropsWithChildren) => {
  const { organization } = useOrganization();

  const hasAccess = organization?.publicMetadata?.courses === 'active';

  return <>{hasAccess ? <>{children}</> : <NotFound />}</>;
};
